import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import styles from "../../pedidos/pedidos_style.module.css";
import { InsumoLocalDto } from "./EstoquePage";
import { useState, useEffect } from "react";
import dayjs from "dayjs";
import {
    defineValueInInput,
    getValueFromInput,
    getElementFromId,
} from "../../../../components/funcForInput";
import removeAllErrorMsg from "../../../../components/funcRemoveAllErros";
import { getCookie } from "../../../../config/cookies";
import { ApiEndpoints, reqPatch, reqPut } from "../../../../config/apiClient";
import { toast } from "react-toastify";
import $ from "jquery";
import "jquery-mask-plugin";
import { getInputDinheiro } from "../../../nf/nfse/emissao/ViewNotaPage";

export default function ModalEstoqueVisualizar({
    show,
    handleClose,
    estoque_dados,
    filtros,
}: iProps) {
    const [estoque, setEstoque] = useState<InsumoLocalDto>(estoque_dados);
    const [estoqueProdutos, setEstoqueProdutos] = useState<any[]>(
        estoque_dados.produtos,
    );

    useEffect(() => {
        defineMaskInputs();
        // eslint-disable-next-line
    }, []);

    async function handleAdicionarProduto() {
        const quantidade: number = Number(getValueFromInput("quantidade_add"));
        if (quantidade <= 0) {
            window.alert("Informe uma quantidade para adicionar no estoque!");
            return;
        }
        let dados = {
            id_empresa: estoque.id_empresa.id_empresa,
            id_produto: estoque.id_produto.id_produto,
            id_unidade: estoque.id_unidade.id_unidade,
            movimentacao: 0,
            quantidade: quantidade,
            observacao: null,
            id_usuario: Number(getCookie("id_user")),
            data_validade: null,
            data_entrada: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            valor: "000.00",
            cod_produtos: [],
        };
        const api = await reqPut(ApiEndpoints.insumosCadastrarEstoque, dados);
        if (api.status === 200) {
            const estoque_novo = api.data;
            let produtosAux = [];
            for (let prod of estoque_novo.produtos) {
                produtosAux.push(prod);
            }
            setEstoque(estoque_novo);
            setEstoqueProdutos(produtosAux);
            defineValueInInput("quantidade_add", 0);
            toast.success("Produtos adicionados!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
    }

    // Valida e aplica as alterações feitas nos inputs gerados dinamicamente dentro de #estoque_produtos
    async function handleSalvarAlteracoes() {
        // oculta mensagens de erro previamente exibidas
        removeAllErrorMsg();

        let formValidado = true;
        const produtosAtualizados: any[] = [];
        let primeiroInvalido: any = null;

        for (let idx in estoqueProdutos) {
            const prod = estoqueProdutos[idx];
            const inputValor: any = getElementFromId(`${idx}-valor`);
            const textareaObs: any = getElementFromId(`${idx}-observacao`);
            let idEstoqueLocal: number = Number(
                getValueFromInput(`${idx}-local`),
            );

            // valor - obrigatório e não pode ser negativo
            const valorNum = Number(getInputDinheiro(`${idx}-valor`))

            if (valorNum < 0) {
                // Valor negativo
                inputValor.nextElementSibling.style.display = "block";
                inputValor.style.border = "1px solid #dc3545";
                formValidado = false;
                if (!primeiroInvalido) primeiroInvalido = inputValor;
            } else if (valorNum === 0) {
                // Valor zerado não permitido
                inputValor.nextElementSibling.style.display = "block";
                formValidado = false;
            }

            produtosAtualizados.push({
                id_codigo: prod.id_codigo,
                id_registro: prod.id_registro,
                valor: getInputDinheiro(`${idx}-valor`),
                observacao: textareaObs ? textareaObs.value : prod.observacao,
                id_estoque_local: idEstoqueLocal === 0 ? null : idEstoqueLocal,
            });
        }

        console.log(produtosAtualizados);
        let dados = {
            id_registro: estoque.id_registro,
            produtos: produtosAtualizados,
        }

        if (!formValidado) {
            if (primeiroInvalido) primeiroInvalido.focus();
            return;
        }
        
        defineMaskInputs();
        editar(dados)
    }
    async function editar(dados: any) {
        // setLoading(true)
        const api = await reqPatch(ApiEndpoints.insumosEditarEstoque, dados);
        if (api.status === 200) {
            toast.success("Lista de Produtos editado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            const estoque_aux = api.data;
            setEstoque(estoque_aux);
            setEstoqueProdutos(estoque_aux.produtos);
        }
        // setLoading(false)
    }
    
    async function handleRemoverProdutos() { 
        let produtosSelecionados = getProdutosSelecionados()
        if (produtosSelecionados.length === 0) { 
            window.alert("Selecione algum produto na lista dos produtos!")
            return
        }
        if (!window.confirm("Tem certeza que deseja retirar os produtos selecionados?")) { 
            return
        }
        let cod_produtos = produtosSelecionados.map((value:any, idx:any, arr:any[]) => { 
            return value.id_codigo 
        })
        let dados = {
            id_empresa: estoque.id_empresa.id_empresa,
            id_produto: estoque.id_produto.id_produto,
            id_unidade: estoque.id_unidade.id_unidade,
            movimentacao: 1,
            quantidade: produtosSelecionados.length,
            observacao: null,
            id_usuario: Number(getCookie("id_user")),
            data_validade: null,
            data_entrada: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            valor: "000.00",
            cod_produtos: cod_produtos,
        };
        const api = await reqPut(ApiEndpoints.insumosCadastrarEstoque, dados);
        if (api.status === 200) {
            const estoque_novo = api.data;
            let produtosAux = [];
            for (let prod of estoque_novo.produtos) {
                produtosAux.push(prod);
            }
            resetProdutosSelecionados(estoqueProdutos)
            setEstoque(estoque_novo);
            setEstoqueProdutos(produtosAux);
            toast.success("Produtos retirados!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
        }
    }
    function getProdutosSelecionados(): any[] { 
        let selecionados: any[] = []
        for (let idx in estoqueProdutos) { 
            let inputCheckbox = getElementFromId(`${idx}-selecionado`)
            let selecionado = inputCheckbox.checked
            if (selecionado) { 
                selecionados.push(estoqueProdutos[idx])
            }
        }
        return selecionados
    }
    function resetProdutosSelecionados(produtosAux: any[]) { 
        for (let idx in produtosAux) { 
            let inputCheckbox = getElementFromId(`${idx}-selecionado`)
            inputCheckbox.checked = false
        }
    }

    return (
        <Modal
            id={styles.modal_insumo_pedido}
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={true}
            size="lg"
        >
            <Modal.Header style={{ display: "block" }}>
                <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <Modal.Title>
                        Produto: {estoque.id_produto.descricao}
                    </Modal.Title>
                    <br></br>
                    <Button onClick={handleClose}>Fechar</Button>
                </div>
                <div>
                    <p>Quantidade atual: {estoque.quantidade_atual}</p>
                    <p>Local armezanado: </p>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div id="estoque_produtos">
                    <Form.Control
                        name="dinheiro_aux"
                        type="text"
                        id="dinheiro_aux"
                        className="valor"
                        style={{ display: "none" }}
                    />
                    <Row className="mb-15-forms">
                        <Col className="col-1">
                            <p>Codigo</p>
                        </Col>
                        <Col className="col-2">
                            <p>Descrição</p>
                        </Col>
                        <Col className="col-3">
                            <p>Observação</p>
                        </Col>
                        <Col className="col-1">
                            <p>Valor</p>
                        </Col>
                        <Col className="col-2">
                            <p>Local</p>
                        </Col>

                        <Col className="col-2">
                            <p>Data Criação</p>
                        </Col>
                        <Col className="col-1">
                            <p>Selecionar</p>
                        </Col>
                    </Row>
                    {estoqueProdutos.map((prod, idx, arr) => {
                        return (
                            <div key={idx} style={{ marginBottom: "20px" }}>
                                <Row className="mb-15-forms div-row">
                                    <Col className="col-1">
                                        <p>#ID{prod.id_codigo}</p>
                                    </Col>
                                    <Col className="col-2">
                                        <p>{estoque.id_produto.descricao}</p>
                                    </Col>
                                    <Col className="col-3">
                                        <Form.Control
                                            id={`${idx}-observacao`}
                                            name={`${idx}-observacao`}
                                            as="textarea"
                                            defaultValue={prod.observacao}
                                            aria-label="..."
                                            cols={1}
                                            rows={1}
                                        />
                                        <div
                                            className="invalid-feedback"
                                            style={{
                                                display: "none",
                                                position: "absolute",
                                            }}
                                        >
                                            Observação inválida (máx. 1000
                                            caracteres)
                                        </div>
                                    </Col>
                                    <Col className="col-1">
                                        <Form.Control
                                            name={`${idx}-valor`}
                                            id={`${idx}-valor`}
                                            type="text"
                                            className="valor"
                                            placeholder=""
                                            defaultValue={prod.valor}
                                        />
                                        <div
                                            className="invalid-feedback"
                                            style={{
                                                display: "none",
                                                position: "absolute",
                                            }}
                                        >
                                            Valor inválido
                                        </div>
                                    </Col>
                                    <Col className="col-2">
                                        <Form.Select
                                            name={`${idx}-local`}
                                            id={`${idx}-local`}
                                            aria-label=""
                                        >
                                            <option value="0">
                                                Não informado
                                            </option>
                                            {filtros.locais.map(
                                                (
                                                    localAux: any,
                                                    idx: any,
                                                    arr: any,
                                                ) => {
                                                    return (
                                                        <option
                                                            key={idx}
                                                            value={
                                                                localAux.value
                                                            }
                                                        >
                                                            {localAux.label}
                                                        </option>
                                                    );
                                                },
                                            )}
                                        </Form.Select>
                                        <div
                                            className="invalid-feedback"
                                            style={{ display: "none" }}
                                        >
                                            Selecione um local
                                        </div>
                                    </Col>

                                    <Col className="col-2">
                                        <p>
                                            {dayjs(prod.data_entrada).format(
                                                "DD/MM/YYYY HH:mm:ss",
                                            )}
                                        </p>
                                    </Col>
                                    <Col className="col-1">
                                        <input className={styles.arquivo_checkbox} id={`${idx}-selecionado`} type="checkbox" />
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </div>

                <div id="estoque_funcoes">
                    <Row className="mb-15-forms">
                        <Col className="col-1">
                            <Form.Group>
                                <Form.Label>Quantidade:</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="quantidade_add"
                                    id="quantidade_add"
                                    min={0}
                                    defaultValue={0}
                                />
                            </Form.Group>
                        </Col>
                        <Col className="col-2">
                            <Form.Group>
                                <Form.Label>&nbsp;</Form.Label>
                                <br></br>
                                <Button
                                    variant="warning"
                                    onClick={() => handleAdicionarProduto()}
                                >
                                    Adicionar Produto
                                </Button>
                            </Form.Group>
                        </Col>
                        <Col className="col-5 div-row">
                            <Form.Group style={{marginRight: "10px"}}>
                                <Form.Label>&nbsp;</Form.Label>
                                <br></br>
                                <Button
                                    variant="success"
                                    onClick={() => {
                                        handleSalvarAlteracoes();
                                    }}
                                >
                                    Salvar alterações
                                </Button>
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>&nbsp;</Form.Label>
                                <br></br>
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        handleRemoverProdutos();
                                    }}
                                >
                                    Retirar Produtos
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                </div>

                <hr></hr>
                <div id={styles.estoque_historico}>
                    <p>Histórico de Movimentações</p>
                    <br></br>
                    {estoque.historico.map((reg, idx, arr) => {
                        return (
                            <div key={idx} style={{width: "99%"}}>
                                <Row>
                                    <Col className="col-2">
                                        {dayjs(reg.data_criacao).format(
                                            "DD/MM/YYYY HH:mm:ss",
                                        )}
                                    </Col>
                                    <Col className="col-3">
                                        {reg.observacao}
                                    </Col>
                                </Row>
                            </div>
                        );
                    })}
                </div>
            </Modal.Body>
            <Modal.Footer style={{ width: "100%" }}>
                {/*<Button variant="success" onClick={() => {}}>
                    Salvar alterações
                </Button>*/}
            </Modal.Footer>
        </Modal>
    );
}
interface iProps {
    show: boolean;
    handleClose: any;
    estoque_dados: InsumoLocalDto;
    filtros: any;
}

function defineMaskInputs() {
    $(".valor").mask("###.###.###.###.###.###.##0,00", {
        reverse: true,
        placeholder: "0,00",
    });
}
